import { css } from 'styled-components';
import type { TopBannerListModel } from 'autogen/swagger/all';
import ItemCarousel from 'components/generic/ScrollSnapSlider/components/ItemCarousel';
import NavigationFadeButton from 'components/generic/ScrollSnapSlider/components/NavigationFadeButton';
import StreamerItem, { StreamerWrapper } from 'components/Streamers/StreamerItem';
import { breakpoint } from 'variables';

const containerStyle = css`
    background-color: ${({ theme }) => theme.ColorBackgroundPrimary};
    gap: 0;

    ${StreamerWrapper} {
        min-width: 65vw;
        
        ${breakpoint.up('768px')} {
            min-width: calc(50% - ${({ theme }) => theme.Spacing6});
        }
    }

    ${StreamerWrapper} {
        flex: 1 0 auto;
        padding: 0 ${({ theme }) => theme.Spacing4};
    }

    ${StreamerWrapper}:first-child {
        padding-left: ${({ theme }) => theme.Spacing16};
    }

    ${StreamerWrapper}:last-child {
        padding-right: ${({ theme }) => theme.Spacing16};
    }
`;

function CarouselList({ topBanners }: TopBannerListModel): JSX.Element {
    return (
        <ItemCarousel
            carouselButtonsIndent="20px"
            scrollContainerCss={containerStyle}
            items={topBanners}
            itemRenderer={(banner, index) => <StreamerItem {...banner} key={index} />}
            arrowRenderer={(props) => <NavigationFadeButton {...props} size="S" />}
        />
    );
}

export default CarouselList;
